import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ICTEffectList, DeltaOf } from '@tencent/slide-sdk-model';
import { ShadowConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/effect/shadow/shadow-converter';
import { ReflectionConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/effect/reflection/reflection-converter';
import { GlowConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/effect/glow/glow-converter';
import { SoftEdgeConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/effect/soft-edge/soft-edge-converter';
import { IEffectModelValCollection } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';

/**
 * 效果
 */
export class EffectConverter {
    /**
     * 效果的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTEffectList>>,
        uiData: IEffectModelValCollection,
    ): void {
        // 阴影
        ShadowConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        // 映像
        ReflectionConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        // 发光
        GlowConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        // 柔化边缘
        SoftEdgeConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
    }

    /**
     * 效果的ui-> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IEffectModelValCollection>>,
        sdkData: DeltaOf<ICTEffectList>,
    ): void {
        // 阴影
        ShadowConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
        // 映像
        ReflectionConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
        // 发光
        GlowConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
        // 柔化边缘
        SoftEdgeConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
    }
}
